export default () => ({
  entity: 'speciality',
  entities: 'specialities',
  specialities: [],
  errors: {
  },
  prefixRouter: 'professional.record.specialities'
})



// WEBPACK FOOTER //
// ./src/app/employee/record/specialities/resources/data.js